/// <amd-module name="Artifacts/Package/Constants" />
export class ExternalRoutes {
  public static readonly BuildResult = "ms.vss-build-web.ci-results-hub-route";
  public static readonly Commit = "ms.vss-code-web.commit-route";
  public static readonly Changeset = "ms.vss-code-web.tfvc-changeset-details-route";
  public static readonly DefinitionHub = "ms.vss-build-web.pipelines-hub-route";
  public static readonly Shelveset = "ms.vss-code-web.tfvc-shelveset-details-route";
  public static readonly GitFiles = "ms.vss-code-web.files-route-git";
  public static readonly TfvcFiles = "ms.vss-code-web.tfvc-files-route";
  public static readonly Release = "ms.vss-releaseManagement-web.cd-release-progress-default-route";
}

export class ExternalContributions {
  public static readonly ReleaseExplorer = "ms.vss-releaseManagement-web.hub-explorer";
  public static readonly ReleaseExplorer2 = "ms.vss-releaseManagement-web.hub-explorer-2";
}

export class ProvenanceKeys {
  public static readonly BuildId = "Build.BuildId";
  public static readonly BuildNumber = "Build.BuildNumber";
  public static readonly CollectionId = "System.CollectionId";
  public static readonly DefinitionId = "System.DefinitionId";
  public static readonly DefinitionName = "Build.DefinitionName";
  public static readonly ProjectId = "System.TeamProjectId";
  public static readonly ReleaseId = "Release.ReleaseId";
  public static readonly ReleaseName = "Release.ReleaseName";
  public static readonly ReleaseDefinitionName = "Release.DefinitionName";
  public static readonly ReleaseDefinitionId = "Release.DefinitionId";
  public static readonly RepositoryId = "Build.Repository.Id";
  public static readonly RepositoryName = "Build.Repository.Name";
  public static readonly RepositoryProvider = "Build.Repository.Provider";
  public static readonly RepositoryUri = "Build.Repository.Uri";
  public static readonly SourceBranch = "Build.SourceBranch";
  public static readonly SourceBranchName = "Build.SourceBranchName";
  public static readonly SourceVersion = "Build.SourceVersion";
  public static readonly ExternalLinkUrl = "External.LinkUrl";
  public static readonly ExternalLinkText = "External.LinkText";
}

export class ProvenanceSource {
  public static readonly InternalBuild = "InternalBuild";
  public static readonly InternalRelease = "InternalRelease";
  public static readonly External = "External";
}

export class VCRouteParameters {
  public static readonly Parameters = "parameters";
  public static readonly Project = "project";
  public static readonly RepoName = "vc.GitRepositoryName";
  public static readonly Shelveset = "ss";
  public static readonly Version = "version";
}

export class ReleaseRouteParameters {
  public static readonly Project = "project";
  public static readonly ReleaseId = "releaseId";
  public static readonly Action = "_a";
  public static readonly ProgressActionValue = "release-pipeline-progress";
}

export class CiConstants {
  public static readonly ProvenanceShowBuild = "ProvenanceShowBuild";
  public static readonly ProvenanceShowRelease = "ProvenanceShowRelease";
  public static readonly ProvenanceShowExternal = "ProvenanceShowExternal";
  public static readonly ProvenanceBuildLinkClicked = "ProvenanceBuildLinkClicked";
  public static readonly ProvenanceBuildDefinitionLinkClicked =
    "ProvenanceBuildDefinitionLinkClicked";
  public static readonly ProvenanceRepositoryLinkClicked = "ProvenanceRepositoryLinkClicked";
  public static readonly ProvenanceCommitLinkClicked = "ProvenanceCommitLinkClicked";
  public static readonly ProvenanceBranchLinkClicked = "ProvenanceBranchLinkClicked";
  public static readonly ProvenanceReleaseLinkClicked = "ProvenanceReleaseLinkClicked";
  public static readonly ProvenanceReleaseDefinitionLinkClicked =
    "ProvenanceReleaseDefinitionLinkClicked";
  public static readonly ProvenanceExternalLinkClicked = "ProvenanceExternalLinkClicked";
}
